import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { NotificationService } from '../services/notification.service';
import { AuthService } from './auth.service';
import { UserRolesService } from '../services/user-roles.service';
import { firstValueFrom } from 'rxjs';
import { Auth, user as getUser } from '@angular/fire/auth';
import { TokenProviderService } from './token-provider.service';

export const LOGIN_PAGE = 'auth/login';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private afAuth: Auth,
    private userService: UserService,
    private errorService: NotificationService,
    private router: Router,
    private authService: AuthService,
    private userRolesService: UserRolesService,
    private tokenProviderService: TokenProviderService,
  ) {}

  public async canActivate() {
    await this.tokenProviderService.signInWithToken();
    const currentUser = await firstValueFrom(getUser(this.afAuth));

    if (!currentUser) {
      this.authService.setRedirectUrl();
      return this.router.createUrlTree([LOGIN_PAGE]);
    }
    if (!currentUser.emailVerified) {
      return this.showErrorAndGoToLogin(
        `Please, verify your email address to access to the system: ${currentUser.email}`,
      );
    }

    if (await this.userService.checkAccess(currentUser)) {
      await this.userRolesService.initRoles();
      return true;
    }

    return this.showErrorAndGoToLogin();
  }

  private showErrorAndGoToLogin(error?: string) {
    this.errorService.showError(
      error || "You don't have permissions. Please contact system administrator",
    );
    this.authService.setRedirectUrl();

    return this.router.createUrlTree([LOGIN_PAGE]);
  }
}
